<template>
  <NsiTable :pageTitle="pageTitle" :apiRoute="apiRoute" :cardName="cardName" :canEdit="canEdit" />
</template>

<script>
  import NsiTable from '../components/NsiTable.vue';

  export default {
    name: 'DocumentTypes',
    components: {
      NsiTable,
    },
    data() {
      return {
        pageTitle: 'Типы документов',
        canEdit: true,
        apiRoute: 'nsidocumenttype',
        cardName: 'DocumentTypeCard',
      };
    },
    created() {},
    methods: {},
  };
</script>
